
import './App.css';
import Home from './Screens/Home';
import { Route, Routes} from 'react-router-dom';
import About from './Screens/About';
import Events from './Screens/Events';
import Ministries from './Screens/Ministries';
import Resources from './Screens/Resources';
import Contact from './Screens/Contact';
import Visit from './Screens/Visit';


function App() {
  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/events" element={<Events />} />
        <Route path="/ministries" element={<Ministries />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact" element={<Contact />} />
        <Route path='/visit' element={<Visit />} />
      </Routes>

  );
}


export default App;
